/**
 * A term whose declaring dataset couldn't be attributed (should be rare —
 * only if a subject has zero quads, which shouldn't happen for anything
 * returned by the model layer) is kept visible regardless of the dataset
 * switcher rather than silently disappearing.
 */
export function filterByActiveDatasets<T extends { datasetId: string }>(
  items: readonly T[],
  activeDatasetIds: ReadonlySet<string>,
): T[] {
  return items.filter(
    (item) => activeDatasetIds.has(item.datasetId) || item.datasetId === "unknown",
  );
}
